export const getTeacherState = (state: any) => state.teacher;
